import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Brain, CheckCircle2 } from 'lucide-react';
interface LoadingScreenProps {
  onComplete: () => void;
}
export function LoadingScreen({
  onComplete
}: LoadingScreenProps) {
  const [textIndex, setTextIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const texts = ['Analizando tus respuestas...', 'Identificando el patrón principal...', 'Preparando recomendaciones prácticas...', 'Generando tu orientación personalizada...'];
  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex(prev => {
        if (prev < texts.length - 1) return prev + 1;
        return prev;
      });
    }, 1000);
    const completeTimeout = setTimeout(() => {
      setIsComplete(true);
    }, 4000);
    const transitionTimeout = setTimeout(() => {
      onComplete();
    }, 4800);
    return () => {
      clearInterval(interval);
      clearTimeout(completeTimeout);
      clearTimeout(transitionTimeout);
    };
  }, [onComplete]);
  return <div className="flex flex-col items-center justify-center min-h-screen bg-white px-6 text-center relative overflow-hidden" data-id="element-60">
      <div className="absolute top-1/4 left-10 w-32 h-32 bg-blue-50 rounded-full blur-3xl opacity-50" data-id="element-61" />
      <div className="absolute bottom-1/4 right-10 w-40 h-40 bg-green-50 rounded-full blur-3xl opacity-50" data-id="element-62" />

      <div className="relative z-10 flex flex-col items-center" data-id="element-63">
        <AnimatePresence mode="wait" data-id="element-64">
          {!isComplete ? <motion.div key="loading-icon" initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.8,
          opacity: 0
        }} className="relative mb-8" data-id="element-65">
              <motion.div animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center shadow-inner" data-id="element-66">
                <Brain className="text-brand-blue" size={48} strokeWidth={1.5} data-id="element-67" />
              </motion.div>
              <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 rounded-full border border-dashed border-blue-200" data-id="element-68">
                <div className="absolute top-0 left-1/2 w-2.5 h-2.5 bg-brand-blue rounded-full -translate-x-1/2 -translate-y-1/2 shadow-sm" data-id="element-69" />
              </motion.div>
            </motion.div> : <motion.div key="success-icon" initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mb-8" data-id="element-70">
              <CheckCircle2 className="text-brand-green" size={52} data-id="element-71" />
            </motion.div>}
        </AnimatePresence>

        <div className="h-14 flex items-center justify-center" data-id="element-72">
          <AnimatePresence mode="wait" data-id="element-73">
            <motion.h2 key={isComplete ? 'done' : textIndex} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} className={`text-interstitial-h2 md:text-interstitial-h2-desktop font-heading font-bold ${isComplete ? 'text-brand-green' : 'text-brand-dark'}`} data-id="element-74">
              {isComplete ? '¡Análisis completado!' : texts[textIndex]}
            </motion.h2>
          </AnimatePresence>
        </div>

        <div className="w-full max-w-xs mt-6 h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-75">
          <motion.div className={`h-full rounded-full ${isComplete ? 'bg-brand-green' : 'bg-brand-blue'}`} initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 4,
          ease: 'linear'
        }} data-id="element-76" />
        </div>
      </div>
    </div>;
}